import { render } from "./ic-add-avatar-big.vue?vue&type=template&id=28217748"
import script from "./ic-add-avatar-big.vue?vue&type=script&lang=js"
export * from "./ic-add-avatar-big.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__